import React from 'react'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { memo } from 'react';
import UserItem from '../common/UserItem';
import { useAuth } from '../../contexts/auth';
import { BdaService } from '../../models/BdaService';
import { Flex, Tag, Tooltip } from 'antd';
import AppTag from '../common/AppTag';

type Props = {
  service: BdaService;
  actions?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onClone?: React.MouseEventHandler<HTMLButtonElement>;
  onEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
  onShowDefinition?: React.MouseEventHandler<HTMLButtonElement>;
}

function ServiceItem({ service, actions, onClick, onClone, onEdit, onDelete, onShowDefinition }: Props) {
  const { loggedUser } = useAuth();

  return (
    <Card className="app-list-item" onClick={onClick}>
      <Card.Header className="list-item-header position-relative bg-service">
        <Flex align="center">
          {service.category && (
            <Tooltip title="Service Category" mouseEnterDelay={0.3}>
              <Badge className="px-2 shadow" bg="pink">{service.category.name}</Badge>
            </Tooltip>
          )}
          <Tag color="blue" className="ms-auto shadow text-uppercase font-xs fw-bold m-0">{service.accessLevel}</Tag>
          {service.deleteDateTime && (<Tag color="red" className="shadow text-uppercase font-xs fw-bold m-0 ms-2">Deprecated</Tag>)}
        </Flex>
        {/* <FontAwesomeIcon className="list-item-icon" icon={iconsMap.get(service.area!) || solid('chart-pie')} /> */}

        <div className="header-content pt-4 pb-2">
          <Tooltip title={service.name} mouseEnterDelay={0.3}>
            <h5 className="list-item-title text-white">{service.name}</h5>
          </Tooltip>
          <Tooltip title="Service version" mouseEnterDelay={0.3}>
            <Badge bg="none" className="service-version shadow">{service.version}</Badge>
          </Tooltip>
          <p className="list-item-description line-clamp-2 mt-1">{service.description}</p>
        </div>

        <Row className="gx-0 position-relative justify-content-center">
          <Col className="text-center" xs={9}>
            {actions || (loggedUser?.sub === service.owner!.id && (
              <>
                <Tooltip title="Show Definition">
                  <button className="circle-button" onClick={onShowDefinition}>
                    <FontAwesomeIcon icon={solid('code')} />
                  </button>
                </Tooltip>

                {!service.deleteDateTime && (
                  <>
                    <Tooltip title="Clone">
                      <button className="circle-button ms-2" onClick={onClone}>
                        <FontAwesomeIcon size="sm" icon={solid('clone')} />
                      </button>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <button className="circle-button ms-2" onClick={onEdit}>
                        <FontAwesomeIcon size="sm" icon={solid('pen')} />
                      </button>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <button className="circle-button ms-2" onClick={onDelete}>
                        <FontAwesomeIcon size="sm" icon={solid('trash')} />
                      </button>
                    </Tooltip>
                  </>
                )}
              </>
            ))}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="p-2">
        <div className="d-flex align-items-center mb-2">
          <Col className="overflow-hidden">
            <UserItem user={service.owner!} organization={service.organization!} />
          </Col>

        </div>

        <Flex className="tags-wrapper">
          {service.tags.length === 0 && <AppTag noTags />}
          {service.tags.map(tag => <AppTag className="me-1" tag={tag} key={tag} />)}
        </Flex>
      </Card.Body>
    </Card>
  )
}

export default memo(ServiceItem);